import { navActions } from "../../Redux/nav/nav.slice"

export default {
  changeSizeSidebar: navActions.navSetProp,
  changeTheme: navActions.navSetProp
}
